import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { CloseOutlined } from "@mui/icons-material";
import {
  Table,
  TableCell,
  TableRow,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Service from "./partner/Service";
import moment from "moment";
import ServiceHistory from "./partner/ServiceHistory";
import PaymentHistory from "./partner/paymentHistory";
import RequestHistory from "./partner/RequestHistory";
import PastRequestHistory from "./partner/PastRequestHistory";
import axios from "axios";
import { deleteRequest, patchRequest, server } from "../config";
import { toast } from "react-toastify";
import ReferalPartners from "./partner/ReferalPartners";

const PartnerProfile = ({ partner, onClose }) => {
  const [value, setValue] = React.useState(0);
  const [openEdit, setOpenEdit] = useState(false);
  const [formData, setFormData] = useState({ ...partner });

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleEditOpen = () => setOpenEdit(true);
  const handleEditClose = () => setOpenEdit(false);

  const handleChangeInput = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleDeletePartner = async () => {   
    if (!window.confirm("Are you sure you want to delete this partner?")) {
      return;
    }
    try {
     const res= await patchRequest(`${server.uri}/users/${partner.userId}`, {
        isDeleted:true
      });
      if(res!==200){  
       toast.error("Failed to delete partner");
       return
      }
      toast.success("Partner deleted successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to delete partner");
    }
  }
  const handleDeletePartnerPermanent = async () => {   
    if (!window.confirm("Are you sure you want to delete this partner?")) {
      return;
    }
    try {
     const res= await deleteRequest(`${server.uri}/users/${partner.userId}/delete`);
      if(res!==204){  
       toast.error("Failed to delete partner");
       return
      }
      toast.success("Partner deleted successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to delete partner");
    }
  }
  const handleUpdate = async () => {
    try {
      await patchRequest(`${server.uri}/users/${partner.userId}`, {
        name: formData.name,
        mobileNumber: formData.mobileNumber,
        city: formData.city,
        status: formData.status,
        pincode: formData.pincode,
        fullAddress: formData.fullAddress,
        wallet: parseFloat(formData.wallet) || 0,
      });
      alert("Partner updated successfully");
      setOpenEdit(false);
    } catch (err) {
      console.error(err);
      alert("Failed to update partner");
    }
  };

  return (
    <>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        {partner?.name}(#{partner?.uniqueId})
      </Typography>

      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "100px",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Services" {...a11yProps(0)} />
          <Tab label="Service History" {...a11yProps(1)} />
          <Tab label="Payment History" {...a11yProps(2)} />
          <Tab label="Request History" {...a11yProps(3)} />
          <Tab label="Past Request History" {...a11yProps(4)} />
          <Tab label="Referal Partners" {...a11yProps(5)} />
          <Tab label="Profile" {...a11yProps(6)} />
        </Tabs>
        <div onClick={onClose} className="cursor-pointer">
          <CloseOutlined />
        </div>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <Service partnerId={partner?.userId} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <ServiceHistory partnerId={partner?.userId} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <PaymentHistory partnerId={partner?.userId} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>
        <RequestHistory partnerId={partner?.userId} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <PastRequestHistory partnerId={partner?.userId} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <ReferalPartners partnerId={partner?.userId} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={6}>
        <Box sx={{ width: "100%" }}>
          {/* Partner Details and Action Buttons */}
          <Box sx={{ display: "flex", gap: 4, mb: 4 }}>
            <Table sx={{ maxWidth: "600px" }} border={2} className="border-2">
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Partner Name-</TableCell>
                <TableCell>{partner?.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Mobile Number-</TableCell>
                <TableCell>{partner?.mobileNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>PinCode-</TableCell>
                <TableCell>{partner?.pincode}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Status-</TableCell>
                <TableCell>{partner?.status}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>City-</TableCell>
                <TableCell>{partner?.city}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Address-</TableCell>
                <TableCell>{partner?.fullAddress}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Wallet Balance-</TableCell>
                <TableCell>₹{partner?.wallet?.toLocaleString("en-IN") || "0"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Joined At-</TableCell>
                <TableCell>
                  {moment(partner?.createdAt).format("DD-MM-YYYY")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Aadhar Card Number
                </TableCell>
                <TableCell>{partner?.aadhaarCardNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Pan Number</TableCell>
                <TableCell>{partner?.panNumber}</TableCell>
              </TableRow>
            </Table>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleEditOpen}
              >
                Edit Partner
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleDeletePartner}
              >
                Delete Partner
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleDeletePartnerPermanent}
              >
                Permanent Delete
              </Button>
            </Box>
          </Box>

          {/* Verification Photos Section */}
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
              Verification Photos
            </Typography>
            <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
              {partner?.aadhaarCardUrl?.[0] && (
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>
                    Aadhaar Card (Front)
                  </Typography>
                  <img
                    src={partner.aadhaarCardUrl[0]}
                    alt="Aadhaar Card Front"
                    style={{
                      width: "300px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "2px solid #e0e0e0",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.02)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                    onClick={() => window.open(partner.aadhaarCardUrl[0], '_blank')}
                  />
                </Box>
              )}
              {partner?.aadhaarCardUrl?.[1] && (
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>
                    Aadhaar Card (Back)
                  </Typography>
                  <img
                    src={partner.aadhaarCardUrl[1]}
                    alt="Aadhaar Card Back"
                    style={{
                      width: "300px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "2px solid #e0e0e0",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.02)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                    onClick={() => window.open(partner.aadhaarCardUrl[1], '_blank')}
                  />
                </Box>
              )}
              {partner?.panCardUrl && (
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>
                    Pan Card
                  </Typography>
                  <img
                    src={partner.panCardUrl}
                    alt="Pan Card"
                    style={{
                      width: "300px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "2px solid #e0e0e0",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.02)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                    onClick={() => window.open(partner.panCardUrl, '_blank')}
                  />
                </Box>
              )}
              {partner?.userProfilePic && (
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>
                    Profile Picture
                  </Typography>
                  <img
                    src={partner.userProfilePic}
                    alt="Profile"
                    style={{
                      width: "300px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "2px solid #e0e0e0",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                    }}
                    onMouseOver={(e) => e.target.style.transform = "scale(1.02)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                    onClick={() => window.open(partner.userProfilePic, '_blank')}
                  />
                </Box>
              )}
              {!partner?.aadhaarCardUrl && !partner?.panCardUrl && !partner?.userProfilePic && (
                <Typography variant="body2" color="textSecondary">
                  No verification photos available
                </Typography>
              )}
            </Box>
          </Box>

          {/* Past Work Photos Section */}
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
              Past Work Photos
            </Typography>
            <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
              {partner?.pastWorkPhotos && partner.pastWorkPhotos.length > 0 ? (
                partner.pastWorkPhotos.map((photoUrl, index) => (
                  <Box key={index}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "600" }}>
                      Work Photo {index + 1}
                    </Typography>
                    <img
                      src={photoUrl}
                      alt={`Past Work ${index + 1}`}
                      style={{
                        width: "300px",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "2px solid #e0e0e0",
                        cursor: "pointer",
                        transition: "transform 0.2s",
                      }}
                      onMouseOver={(e) => e.target.style.transform = "scale(1.02)"}
                      onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                      onClick={() => window.open(photoUrl, '_blank')}
                    />
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No past work photos available
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </CustomTabPanel>

      {/* Edit Partner Modal */}
      <Dialog open={openEdit} onClose={handleEditClose}>
        <DialogTitle>Edit Partner</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            name="name"
            label="Partner Name"
            value={formData.name || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="mobileNumber"
            label="Mobile Number"
            value={formData.mobileNumber || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="city"
            label="City"
            value={formData.city || ""}
            onChange={handleChangeInput}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              name="status"
              value={formData.status || ""}
              onChange={handleChangeInput}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="verified">Approved</MenuItem>
              <MenuItem value="unverified">Rejected Due to Verification</MenuItem>
              <MenuItem value="rejected">Rejected Due to Other</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            margin="dense"
            name="pincode"
            label="Pin Code"
            value={formData.pincode || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="fullAddress"
            label="Address"
            value={formData.fullAddress || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="wallet"
            label="Wallet Balance"
            type="number"
            value={formData.wallet ?? ""}
            onChange={handleChangeInput}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PartnerProfile;
